/**
 * Runtime environment flags, centralised so hooks/components never read
 * import.meta.env directly (and so tests can mock one module).
 *
 * VITE_OFFLINE_AUTH=true is an explicit opt-in for running the dashboard
 * with no backend: login is synthetic and API-backed panels show their
 * empty/error states.
 */

export const OFFLINE_AUTH = import.meta.env.VITE_OFFLINE_AUTH === "true";
export const USE_API = !OFFLINE_AUTH;

/**
 * Maximum size (bytes) of an output artifact eligible for in-browser text/JSON
 * preview (F05 FR4). Larger artifacts are download-only. Default 64 KiB.
 */
export const PREVIEW_MAX_BYTES = Number(import.meta.env.VITE_PREVIEW_MAX_BYTES || 65536);
